module.exports = __webpack_public_path__ + "static/customize1-76a1efb6f1d5eb12e4564c47a9a32ab2.png";